module.exports = __webpack_public_path__ + "img/16_3.41044e35.png";